(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
    	var roles = ['Administrators', 'DAC Content Administrator', 'DAC Content User'];
        $stateProvider
        .state('dac-content-main.nasrac-source', {
            parent: 'dac-content-main',
            url: '/nasrac-source',
            templateUrl: 'app/dac-content/nasrac-source/nasrac-sources.html',
            controller: 'NasracSourceController',
            controllerAs: 'vm',
            data: {
                authorities: roles,
                pageTitle: 'nasracApp.nasracSource.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracSource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dac-content-main.nasrac-source.new', {
            parent: 'dac-content-main.nasrac-source',
            url: '/new',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-dialog.html',
                    controller: 'NasracSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                               // sourceId: null,
                                sourceName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('dac-content-main.nasrac-source');
                });
            }]
        })
        .state('dac-content-main.nasrac-source.edit', {
            parent: 'dac-content-main.nasrac-source',
            url: '/{id}/edit',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-dialog.html',
                    controller: 'NasracSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NasracSource', function(NasracSource) {
                            return NasracSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dac-content-main.nasrac-source.delete', {
            parent: 'dac-content-main.nasrac-source',
            url: '/{id}/delete',
            data: {
                authorities: roles
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dac-content/nasrac-source/nasrac-source-delete-dialog.html',
                    controller: 'NasracSourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NasracSource', function(NasracSource) {
                            return NasracSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dac-content-main.nasrac-source', null, { reload: 'dac-content-main.nasrac-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
